@import '../../../constants/spacing.module.less';

.preview {
  height: 100%;
}

.preview-container {
  flex: 1;
}

.pdf-container {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
  display: flex;
  justify-content: center;
  padding: @space-24;
}

.loading-container {
  justify-content: center;
  align-items: center;
  min-height: 500px;
}

.loading {
  position: unset;
}

/* react-pdf wraps canvas in a div; margin auto on the wrapper centers when smaller than container,
   left-aligns when zoomed larger (overflow scrollable to the right). */
.pdf-container > div {
  margin: 0 auto;
}

.pdf-container canvas {
  display: block;
}

/* :global and !important are needed because react-pdf applies an inline background-color style on .react-pdf__Page */
.pdf-container :global(.react-pdf__Page) {
  background-color: #f5f5f5 !important;
}

.page-spacing {
  margin-top: @space-16;
}
